import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import moment from 'moment'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useSelector } from 'store/hooks/useSelector'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { ErrorAlert, PageLoadingSpinner, useAdjustPageHeadEntities } from 'ui_kit_qmd'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTimezoneSelect, allTimezones } from 'react-timezone-select'
import { PROVIDER_EVENT_NAMES, tracking } from 'lib/segment/tracking'
import { EventLocations } from 'lib/segment/constants'
import ringIcon from '../../../images/common/ring.png'
import { appInsights } from '../../../utils/appInsights'
import { getTimeZones, getTabId, parseTimeZone, parseUserDateTime } from '../../../utils/common'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'
import {
  COMPLETE,
  DISCARD_CHANGES_TEXT,
  ENDED,
  LOCAL_STORAGE_STATE_TO_PAST_VISIT,
  NO_NOTES_TEXT,
  NO_PATIENT_INSTRUCTIONS_TEXT,
  OTHER_DROPDOWN_OPTION,
  PATIENT_CHART_PAGE_PATH,
  PATIENT_CHARTS_TEXT,
  PATIENT_INSTRUCTIONS_EDITOR_TITLE_TEXT,
  PATIENT_INSTRUCTIONS_TITLE_TEXT,
  PATIENTS_CHARTS_PAGE_PATH,
  RESOLVED,
  SAVE_CHANGES_TEXT,
  UNRESOLVED,
  UNSAVED_CHANGES_TEXT,
  UNSAVED_CHANGES_VISIT_NOTES_POPUP_BODY_TEXT,
  VISIBLE_TO_PATIENT_IN_VISIT_SUMMARY_TEXT,
  VISIT_NOTE_BLOCK_EDITOR_TITLE,
  VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE,
  VISIT_NOTE_TEXT,
  PATIENT_UPCOMING_VISIT_PAGE_PATH,
  VISIT_CANCELED_TITLE,
  VISIT_CANCELED_WITH_CHANGES_BODY,
  VISIT_CANCELED_NO_CHANGES_BODY,
  SAVE_AND_CLOSE_TEXT,
  CLOSE_WITHOUT_SAVING_TEXT,
  OKAY_TEXT,
  VISIT_CANCELED_WITH_CHANGES_SUB,
} from '../../../utils/constants'

import './PatientPastVisitNotes.scss'
import { PastVisitNotesHeader } from './components/PastVisitNotesHeader/PastVisitNotesHeader'
import { PatientInfoCard } from './components/PatientInfoCard/PatientInfoCard'
import { NotesSection } from './components/NotesSection/NotesSection'
import { PrescriptionsSection } from './components/PrescriptionsSection/PrescriptionsSection'
import { ConfirmationPopup } from '../../../components/confirmation-popup/confirmationpopup'
import {
  completeVisit,
  getPastVisitInfo,
  getPastVisits,
  getPatientChart,
  savePatientInstructionsAddendum,
  saveVisitNotesAddendum,
  searchForICDCodes,
  unresolveVisit,
  updateICDCodes,
} from '../../../store/charts/ChartsThunk'
import errorIcon from '../../../images/common/error-icon.svg'
import {
  deletePatientInstructions,
  deleteVisitNotes,
  savePatientInstructions,
  saveVisitNotes,
} from '../../../store/waitingRoom/WaitingRoomThunk'
import {
  setError,
  setError as setWaitingRoomError,
  setIsPatientInstructionsSavedSuccess,
  setIsVisitNotesSavedSuccess,
} from '../../../store/waitingRoom/WaitingRoomActions'
import {
  clearPastVisitInfoData,
  setChartError,
  setICDCodeUpdateSuccess,
  setIsChangedVisitStatusSuccess,
} from '../../../store/charts/ChartsActions'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { setEditRemarkId, getRemarks, clearCancelledVisitId } from '../../../store/visits/VisitsActions'
import UnresolvedVisitReasonPopUp from '../../../components/unresolved-visit-reason-pop-up/UnresolvedVisitReasonPopUp'
import { LOGOUT } from '../../../store/auth/AuthConstants'
import { ICDCodes } from '../../../components/icd-codes/ICDCodes'
import { generateLoggVisitsAccessData, postHIPAALogMessage } from '../../../utils/HippaLoggingHelper'
import { PastVisitNotesListener } from './PastVisitNotesListener'
import { ChartCard } from '../patient-chart/components/chart-card/ChartCard'

import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import plus from '../../../images/common/plusIcon.png'
import { createVisitRemarks, updateUpcomingVisitRemark } from '../../../store/patient-side-panel/PatientSidePanelThunk'
import { AddRemark } from './components/AddRemark/AddRemark'
import { VisitRemarksContent } from './components/VisitRemarksContent/VisitRemarksContent'
import { formatNameForPatientChartTitle } from '../patient-chart/helper'
import { DeleteRemarkPopup } from './components/DeleteRemarkPopup/DeleteRemarkPopup'
import { VisitMethods } from '../../../constants/VisitMethods'
import { trackSaveVisitNote, useTrackViewVisitNote } from './tracking'
import { PageLayout } from 'components/page-layouts/PageLayout'
import _ from 'lodash'

const unresolvedVisitPopUpTextBoxCounterLimit = 200

const errorAlertContainerStyle = { width: 550, height: 56, zIndex: 1000000009, background: '#fdf5f2' }

// @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
let actualSortedIcdCodesListForBlurUpdate = []

const AddRemarkBtnStyle = {
  maxHeight: 40,
  width: 66,
  justifyContent: 'center',
  marginTop: 20,
}

const NewRemarkBtnImgStyle = {
  height: 16.5,
  width: 16.5,
  marginRight: 5,
}

const additionalChartCardStyle = { minHeight: 'auto' }

export const PatientPastVisitNotes = memo(() => {
  const params = new URLSearchParams(window.location.search)
  const tabId = getTabId()
  const navigate = useNavigate()
  const location = useLocation()
  const isUpcomingVisit = location.pathname === PATIENT_UPCOMING_VISIT_PAGE_PATH
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const cancelledVisitId = useSelector((state) => state.visitsPage.cancelledVisitId)

  const [showVisitRemarks, setShowVisitRemarks] = useState(false)
  const [isOpenRemarksFirstTime, setIsOpenRemarksFirstTime] = useState(true)
  const [loadingTimerId, setLoadingTimerId] = useState(null)

  if (!location.state) {
    // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
    location.state = JSON.parse(safeLocalStorage.get(LOCAL_STORAGE_STATE_TO_PAST_VISIT))
  }

  const patientId = location.state?.patientId || params.get('patientId')
  const visitId = location.state?.visitId || params.get('visitId')
  const isVisitCancelled = cancelledVisitId === visitId

  let popupTitle = ''
  let popupMessageSub = ''
  let popupMessage = ''
  let primaryButtonText = ''
  let secondaryButtonText = ''

  if (!patientId) {
    navigate(PATIENTS_CHARTS_PAGE_PATH, { replace: true })
  }

  const dispatch = useDispatch()
  const currentICDCodesList = useRef([])
  const currentSortedICDCodesList = useRef([])
  const initialVisitNoteValueRef = useRef('')
  const visitNoteLocalValueRef = useRef('')
  const breadCrumbsLocation = useRef({})
  const initialPatientInstructionsValueRef = useRef('')
  const patientInstructionsLocalValueRef = useRef('')
  const isEditingICDCodes = useRef(false)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.chartsReducer.visitInfo[visitId]?.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const remarksLoading = useSelector((state) => state.visitsPage.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const editRemarkId = useSelector((state) => state.visitsPage.editRemarkId)

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.chartsReducer.visitInfo[visitId]?.error)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const notesChangeLoading = useSelector((state) => state.waitingRoomReducer.notesChangeLoading)
  const providerProfile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const icdCodesUpdatedSuccess = useSelector((state) => state.chartsReducer.visitInfo[visitId]?.icdCodesUpdatedSuccess)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const waitingRoomError = useSelector((state) => state.waitingRoomReducer.error)
  const currentProviderId = useSelector((state) => state.waitingRoomReducer.providerProfile.ProviderId)
  const patientInfo = useSelector((state) => state.chartsReducer.patientInfo[patientId])
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const visitInfo = useSelector((state) => state.chartsReducer.visitInfo[visitId])
  const isNoteAddendumSuccessfullyAdded = useSelector(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    (state) => state.chartsReducer.visitInfo[visitId]?.isNoteAddendumSuccessfullyAdded,
  )
  const isPatientInstructionsAddendumSuccessfullyAdded = useSelector(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    (state) => state.chartsReducer.visitInfo[visitId]?.isPatientInstructionsAddendumSuccessfullyAdded,
  )

  useTrackViewVisitNote({ visitId, isUpcomingVisit })

  const [editRemark, setEditRemark] = useState('')
  const [isAddRemarkOpen, setAddRemarkOpen] = useState(false)
  const [textareaValue, setTextareaValue] = useState('')
  const [forceLoading, setForceLoading] = useState(false)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onTextareaValueChange = useCallback((event) => {
    setTextareaValue(event.target.value)
  }, [])

  const { FirstName, LastName } = patientInfo || {}
  const pageTitle = `${formatNameForPatientChartTitle(FirstName, LastName)} - ${
    isUpcomingVisit ? 'Upcoming Visit Notes' : 'Past Visit Notes'
  }`
  const pageHeader = useAdjustPageHeadEntities({
    title: pageTitle,
  })
  const isInPersonVisit = visitInfo?.Method === VisitMethods.INPERSON

  useEffect(() => {
    if (!patientInfo && patientId) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientChart(patientId, tabId))
    }
  }, [])

  const visitICDCodes = useSelector(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    (state) => state.chartsReducer.visitInfo[visitId]?.visitICDCodes,
    (a, b) => {
      if (a?.length === b?.length) {
        for (let i = 0; i < a?.length; i += 1) {
          if (!_.isEqual(a[i], b[i])) {
            return false
          }
        }
      } else {
        return false
      }
      return true
    },
  )

  const icdAPISearchResults = useSelector(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    (state) => state.chartsReducer.visitInfo[visitId]?.icdCodesSearchResults,
    (a, b) => {
      if (a?.results?.length === b?.results?.length) {
        for (let i = 0; i < a?.results?.length; i += 1) {
          if (!_.isEqual(a?.results[i], b?.results[i])) {
            return false
          }
        }
      } else {
        return false
      }
      if (b?.searchId !== a?.searchId) return false

      return true
    },
  )

  const pastVisits = useSelector((state) => state.chartsReducer.patientInfo?.pastVisits || [])
  // @ts-expect-error TS2551 -- MIGRATION: not approved, fix when encountered
  const isVisitNotesSavedSuccess = useSelector((state) => state.waitingRoomReducer.isVisitNotesSavedSuccess)
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const timeZone = parseTimeZone(profile.TimeZone)

  const [userTimeZone, setUserTimeZone] = useState(timeZone)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const remarks = useSelector((state) => state.visitsPage.remarks)
  const visitRemarks = remarks?.[visitId]
  const isPatientInstructionSavedSuccess = useSelector(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    (state) => state.waitingRoomReducer.isPatientInstructionSavedSuccess,
  )
  const isEndedStatus = visitInfo?.Status === 'ended'
  const isCancelledStatus = visitInfo?.Status === 'cancelledbypatient' || visitInfo?.Status === 'cancelledbyadmin'

  const [initialVisitNoteValue, setInitialVisitNoteValue] = useState((value = '') => {
    initialVisitNoteValueRef.current = value
    return value
  })
  const [initialPatientInstructionsValue, setInitialPatientInstructionsValue] = useState((value = '') => {
    initialPatientInstructionsValueRef.current = value
    return value
  })
  const [visitNoteLocalValue, setVisitNoteLocalValue] = useState((value = '') => {
    visitNoteLocalValueRef.current = value
    return value
  })
  const [patientInstructionsLocalValue, setPatientInstructionsLocalValue] = useState((value = '') => {
    patientInstructionsLocalValueRef.current = value
    return value
  })
  const [isConfirmationPopUpOpened, setIsConfirmationPopUpOpened] = useState(false)
  const [providerInfo, setProviderInfo] = useState(visitInfo?.Provider || providerProfile)
  const [visitNotesList, setVisitNotesList] = useState([])
  const [patientInstructionsList, setPatientInstructionsList] = useState([])
  const [isOwnVisitEditMode, setIsOwnVisitEditMode] = useState(false)
  const [isCloseBtnClicked, setIsCloseBtnClicked] = useState(false)

  const [isSaveConfirmationBtnClicked, setIsSaveConfirmationBtnClicked] = useState(false)
  const [isSomeValueWasChanged, setIsSomeValueWasChanged] = useState(false)
  const [isNotesAddendumPressed, setIsNotesAddendumPressed] = useState(false)
  const [isPatientInstructionsAddendumPressed, setIsPatientInstructionsAddendumPressed] = useState(false)
  const [notesAddendumText, setNotesAddendumText] = useState('')
  const [notesAddendumError, setNotesAddendumError] = useState('')
  const [patientInstructionsAddendumText, setPatientInstructionsAddendumText] = useState('')
  const [patientInstructionsAddendumError, setPatientInstructionsAddendumError] = useState('')
  const [isUnresolvedReasonPopUpOpened, setIsUnresolvedReasonPopUpOpened] = useState(false)
  const [unresolvedReasonPopUpDropdownValue, setUnresolvedReasonPopUpDropdownValue] = useState('')
  const [unresolvedReasonPopUpMessageText, setUnresolvedReasonPopUpMessageText] = useState('')
  const [isUnresolvedReasonPopUpError, setIsUnresolvedReasonPopUpError] = useState('')
  const [newActiveTab, setNewActiveTab] = useState('')
  const [icdSearchResults, setICDSearchResults] = useState(null)
  const [sortedVisitICDCodes, setSortedVisitICDCodes] = useState([])
  const [addedICDCodes, setAddedICDCodes] = useState([])
  const [icdCodeSearchId, setICDCodeSearchId] = useState(0)
  const [forceSearchLoading, setForceSearchLoading] = useState(false)
  const [localICDCodesError, setLocalICDCodesError] = useState('')
  const [searchText, setSearchText] = useState('')
  const [isEditingIcdCodes, setIsEditingIcdCodes] = useState(false)
  const [unMounting, setUnMounting] = useState(false)
  const [icdCodesChanged, setICDCodesChanged] = useState(false)
  const [initialSortedIcdCodes, setSortedIcdCodesFromAPI] = useState([])
  const [isIcdCodesChanged, setIcdCodesChanged] = useState(false)
  const [newNoteValue, setNewNoteValue] = useState('')
  const [newPatientInstructionValue, setNewPatientInstructionValue] = useState('')
  const [isResetEditModeIcdCodes, setIsResetEditModeIcdCodes] = useState(false)
  const [endedVisitId, setEndedVisitId] = useState(null)
  const [localError, setLocalError] = useState('')
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [isForceUpdateIcdCodes, setIsForceUpdateIcdCodes] = useState(false)
  const [isNeedToCheckEndedPastVisitBeforeRedirect, setIsNeedToCheckEndedPastVisitBeforeRedirect] = useState(false)
  const [isNeedToCheckUpcomingVisitBeforeRedirect, setIsNeedToCheckUpcomingVisitBeforeRedirect] = useState(false)

  if (isVisitCancelled && initialVisitNoteValue !== visitNoteLocalValue) {
    // Variant 2: Visit cancelled with unsaved changes
    popupTitle = VISIT_CANCELED_TITLE
    popupMessage = VISIT_CANCELED_WITH_CHANGES_BODY
    popupMessageSub = VISIT_CANCELED_WITH_CHANGES_SUB
    primaryButtonText = SAVE_AND_CLOSE_TEXT
    secondaryButtonText = CLOSE_WITHOUT_SAVING_TEXT
  } else if (isVisitCancelled && initialVisitNoteValue === visitNoteLocalValue) {
    // Variant 3: Visit cancelled without unsaved changes
    popupTitle = VISIT_CANCELED_TITLE
    popupMessage = VISIT_CANCELED_NO_CHANGES_BODY
    primaryButtonText = OKAY_TEXT
    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
    secondaryButtonText = null // No secondary button
  } else if (initialVisitNoteValue !== visitNoteLocalValue) {
    // Variant 1: Unsaved changes without visit cancellation
    popupTitle = UNSAVED_CHANGES_TEXT
    popupMessage = UNSAVED_CHANGES_VISIT_NOTES_POPUP_BODY_TEXT
    primaryButtonText = SAVE_CHANGES_TEXT
    secondaryButtonText = DISCARD_CHANGES_TEXT
  } else {
    // No popup needed
  }

  const onSaveVisitNote = () => {
    const trimmedNoteLocalValue = visitNoteLocalValue.trim()

    if (initialVisitNoteValue !== trimmedNoteLocalValue) {
      if (isVisitCancelled && !isConfirmationPopUpOpened) {
        // Open the ConfirmationPopup with cancellation-specific messages
        setIsConfirmationPopUpOpened(true)
        return // Prevent further actions until user responds
      }

      if (trimmedNoteLocalValue) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(saveVisitNotes(visitId, trimmedNoteLocalValue))
      } else {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(deleteVisitNotes(visitId))
      }

      trackSaveVisitNote(visitInfo)
    } else if (isVisitCancelled) {
      setIsConfirmationPopUpOpened(true)
      // Prevent further actions unt
    } else if (isUpcomingVisit) {
      navigate(`${PATIENT_CHART_PAGE_PATH}?id=${patientId}&ref=${EventLocations.visitNote}`)
    } else {
      setIsNotesAddendumPressed(false)
    }
  }
  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setUserTimeZone(parseTimeZone(profile?.TimeZone))
  }, [profile])

  const timezones = getTimeZones(allTimezones)
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })
  const parsedAdminTimeZoneAbbr =
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    parseTimezone(userTimeZone)?.label ?? parseTimezone(parseTimeZone(userTimeZone ?? ''))?.label

  const onSavePatientInstructions = () => {
    const trimmedPatientInstructionsLocalValue = patientInstructionsLocalValue.trim()

    if (initialPatientInstructionsValue !== trimmedPatientInstructionsLocalValue) {
      if (trimmedPatientInstructionsLocalValue) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(savePatientInstructions(visitId, trimmedPatientInstructionsLocalValue))
      } else {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(deletePatientInstructions(visitId))
      }
    } else {
      setIsPatientInstructionsAddendumPressed(false)
    }
  }

  const onSetVisitStatus = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (value === COMPLETE) {
        if (sortedVisitICDCodes.length === 0 && !isInPersonVisit) {
          setLocalError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
          setLocalICDCodesError(getUserFriendlyErrorMessage(errorCodes.ICD_CODE_MISSING))
          return
        }
        onSaveVisitNote()
        onSavePatientInstructions()
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(completeVisit(visitId, tabId))
      }
      if (value === UNRESOLVED) {
        setLocalICDCodesError('')
        setIsUnresolvedReasonPopUpOpened(true)
      }
    },
    [dispatch, visitId, sortedVisitICDCodes, visitNoteLocalValue, patientInstructionsLocalValue],
  )

  const toggleVisitRemarks = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newValue, openNewRemark) => {
      if (!openNewRemark && showVisitRemarks && isAddRemarkOpen) {
        setAddRemarkOpen(false)
      }

      if (visitId && isOpenRemarksFirstTime) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(getRemarks(visitId))
        setIsOpenRemarksFirstTime(false)
      }

      if (!showVisitRemarks) {
        tracking.trackEvent(PROVIDER_EVENT_NAMES.EXPAND_VISIT_REMARKS, {
          FromDateTime: visitInfo?.FromDateTime,
          IsNewForPatient: visitInfo?.IsNewForPatient,
          IsPatientAvailable: visitInfo?.IsPatientAvailable,
          Method: visitInfo?.Method,
          PatientId: visitInfo?.PatientId,
          ServiceTypeName: visitInfo?.ServiceTypeName,
          Status: visitInfo?.Status,
          ToDateTime: visitInfo?.ToDateTime,
          VisitId: visitInfo?.VisitId,
          VisitTypeName: visitInfo?.VisitTypeName,
        })
      }

      setShowVisitRemarks(newValue)
    },
    [dispatch, isOpenRemarksFirstTime, visitId, showVisitRemarks, isAddRemarkOpen],
  )

  const addendumNoteRef = useRef(null)
  const addendumPatientInstructionsRef = useRef(null)

  useEffect(() => {
    if (visitId && patientId) {
      postHIPAALogMessage(
        generateLoggVisitsAccessData({
          visitId,
          patientId,
          userId: providerProfile?.ProviderId || '',
        }),
      )
    }
  }, [visitId, patientId])

  useEffect(() => {
    if (editRemarkId) {
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      const remarkForEdit = visitRemarks?.remarksList.find(({ RemarkId }) => RemarkId === editRemarkId)
      setEditRemark(remarkForEdit)
    }
  }, [editRemarkId, visitRemarks])
  useEffect(() => {
    if (editRemark) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setTextareaValue(editRemark.Message)
      setAddRemarkOpen(true)
    }
  }, [editRemark])

  useEffect(() => {
    setIsFirstRender(false)
  }, [])

  useEffect(() => {
    const trimmedNoteLocalValue = visitNoteLocalValue.trim()
    const trimmedPatientInstructionsLocalValue = patientInstructionsLocalValue.trim()

    const isNotesChanged = initialVisitNoteValue !== trimmedNoteLocalValue

    const isPatientInstructionsChanged = initialPatientInstructionsValue !== trimmedPatientInstructionsLocalValue

    if (isEndedStatus) {
      setIsNeedToCheckEndedPastVisitBeforeRedirect(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        (initialVisitNoteValue && isNotesChanged) || (initialPatientInstructionsValue && isPatientInstructionsChanged),
      )
      setIsSomeValueWasChanged(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        (initialVisitNoteValue && isNotesChanged) || (initialPatientInstructionsValue && isPatientInstructionsChanged),
      )
    }

    if (isUpcomingVisit) {
      setIsNeedToCheckUpcomingVisitBeforeRedirect(isNotesChanged)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setIsSomeValueWasChanged(initialVisitNoteValue && isNotesChanged)
    }
  }, [visitNoteLocalValue, patientInstructionsLocalValue, initialVisitNoteValue, initialPatientInstructionsValue])

  useEffect(() => {
    if (searchText.length < 1 && icdAPISearchResults?.searchId === icdCodeSearchId) {
      setICDSearchResults(null)
      setForceSearchLoading(false)

      return
    }
    if (icdAPISearchResults?.results && icdAPISearchResults.searchId === icdCodeSearchId) {
      setICDSearchResults(icdAPISearchResults.results)
      setForceSearchLoading(false)
    }
  }, [icdAPISearchResults])

  useEffect(() => {
    if (endedVisitId === visitId) {
      setEndedVisitId(null)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPastVisitInfo({ visitId, patientId }))
    }
  }, [endedVisitId])

  useEffect(() => {
    if (visitICDCodes) {
      if (isEditingIcdCodes) {
        setIsForceUpdateIcdCodes(true)
      } else {
        dispatch(setICDCodeUpdateSuccess(false, visitId))
        const sortedCodes = [...visitICDCodes].sort((a, b) => a.Code.localeCompare(b.Code))
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setSortedVisitICDCodes(sortedCodes)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setSortedIcdCodesFromAPI(sortedCodes)
        actualSortedIcdCodesListForBlurUpdate = sortedCodes
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setAddedICDCodes(sortedCodes)
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        currentICDCodesList.current = [...sortedCodes]
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        currentSortedICDCodesList.current = [...sortedCodes]
        if (localICDCodesError) {
          setLocalICDCodesError('')
        }
      }
    }
  }, [visitICDCodes, isEditingIcdCodes])

  useEffect(() => {
    if (isEditingIcdCodes && isResetEditModeIcdCodes) {
      setIsEditingIcdCodes(false)
      isEditingICDCodes.current = false
      setSearchText('')
      setICDSearchResults(null)
      setIsResetEditModeIcdCodes(false)
    }
  }, [isResetEditModeIcdCodes])

  useEffect(() => {
    if (sortedVisitICDCodes.length !== initialSortedIcdCodes.length) {
      setIcdCodesChanged(true)
      return
    }

    const sortedVisitICDCodesIdsList = sortedVisitICDCodes.map(({ IcdCodeId }) => IcdCodeId)
    const initialSortedIcdCodesIdsList = initialSortedIcdCodes.map(({ IcdCodeId }) => IcdCodeId)

    const isDifferentIcdCodes = !!initialSortedIcdCodesIdsList.find(
      (initialIcdCodeId) => !sortedVisitICDCodesIdsList.includes(initialIcdCodeId),
    )

    if (isDifferentIcdCodes) {
      setIcdCodesChanged(true)
      return
    }

    setIcdCodesChanged(false)
  }, [sortedVisitICDCodes])

  const onPressSaveNoteAddendum = useCallback(() => {
    tracking.trackEvent(PROVIDER_EVENT_NAMES.ADD_ADDENDUM_TO_VISIT_NOTES, {
      FromDateTime: visitInfo.FromDateTime,
      IsNewForPatient: visitInfo.IsNewForPatient,
      IsPatientAvailable: visitInfo.IsPatientAvailable,
      Method: visitInfo.Method,
      PatientId: visitInfo.PatientId,
      ServiceTypeName: visitInfo.ServiceTypeName,
      ToDateTime: visitInfo.ToDateTime,
      VisitId: visitInfo.VisitId,
      VisitTypeName: visitInfo.VisitTypeName,
    })

    if (!notesAddendumText.trim()) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setNotesAddendumError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Note addendum'))
      dispatch(setChartError({ errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS), visitId, tabId }))
    } else {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(saveVisitNotesAddendum({ visitId, Note: notesAddendumText.trim(), tabId }))
    }
  }, [dispatch, notesAddendumText, visitId, visitInfo, tabId])

  const onPressSavePatientInstructionsAddendum = useCallback(() => {
    tracking.trackEvent(PROVIDER_EVENT_NAMES.ADD_ADDENDUM_TO_PATIENT_INSTRUCTIONS, {
      FromDateTime: visitInfo.FromDateTime,
      IsNewForPatient: visitInfo.IsNewForPatient,
      IsPatientAvailable: visitInfo.IsPatientAvailable,
      Method: visitInfo.Method,
      PatientId: visitInfo.PatientId,
      ServiceTypeName: visitInfo.ServiceTypeName,
      ToDateTime: visitInfo.ToDateTime,
      VisitId: visitInfo.VisitId,
      VisitTypeName: visitInfo.VisitTypeName,
    })

    if (!patientInstructionsAddendumText.trim()) {
      setPatientInstructionsAddendumError(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Patient instructions addendum'),
      )
      dispatch(setChartError({ errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS), visitId, tabId }))
    } else {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        savePatientInstructionsAddendum({
          visitId,
          PatientInstructions: patientInstructionsAddendumText.trim(),
          tabId,
        }),
      )
    }
  }, [dispatch, patientInstructionsAddendumText, visitId, visitInfo, tabId])

  const onNotesSectionPressAddendum = useCallback(() => {
    setIsNotesAddendumPressed(true)
    setTimeout(() => {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      addendumNoteRef?.current?.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }, [])
  const onNotesSectionPressCancelAddendum = useCallback(() => {
    setIsNotesAddendumPressed(false)
    setNotesAddendumText('')
    setNotesAddendumError('')
  }, [])

  const onSetNotesAddendumTextValue = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setNotesAddendumError('')
      dispatch(setChartError({ errorMsg: '', visitId, tabId }))
      setNotesAddendumText(value)
    },
    [dispatch],
  )

  const onSetPatientsInstructionsAddendumTextValue = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setPatientInstructionsAddendumError('')
      dispatch(setChartError({ errorMsg: '', visitId, tabId }))
      setPatientInstructionsAddendumText(value)
    },
    [dispatch],
  )

  const onPatientInstructionsSectionPressAddendum = useCallback(() => {
    setIsPatientInstructionsAddendumPressed(true)
    setTimeout(() => {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      addendumPatientInstructionsRef?.current?.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }, [])
  const onPatientInstructionsSectionPressCancelAddendum = useCallback(() => {
    setIsPatientInstructionsAddendumPressed(false)
    setPatientInstructionsAddendumText('')
    setPatientInstructionsAddendumError('')
  }, [])

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const crumbsConfig = useMemo(
    () => [
      {
        site: PATIENT_CHARTS_TEXT,
        location: PATIENTS_CHARTS_PAGE_PATH,
      },
      {
        site: `${patientInfo?.FirstName || ''} ${patientInfo?.LastName || ''}`,
        location: `${PATIENT_CHART_PAGE_PATH}?id=${patientId}&ref=${EventLocations.visitNote}`,
      },
      {
        site: VISIT_NOTE_TEXT,
        location: '',
      },
    ],
    [patientInfo],
  )

  useEffect(() => {
    if (!patientId) return
    if (!patientInfo) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientChart(patientId))
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(getPastVisits(patientId))
    }
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getPastVisitInfo({ visitId, patientId }))

    return () => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setIsVisitNotesSavedSuccess())
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setIsPatientInstructionsSavedSuccess())
      dispatch(setIsChangedVisitStatusSuccess(false, visitId))
      dispatch(clearPastVisitInfoData())

      window.onbeforeunload = null
      window.onpopstate = null
    }
  }, [])

  useEffect(() => {
    if (unMounting) {
      onSaveVisitNote()
      onSavePatientInstructions()
    }
    setUnMounting(false)
  }, [unMounting])

  useEffect(() => {
    if (!isUpcomingVisit && isEndedStatus) {
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      const callBack = ({ target }) => {
        if (
          target.className === 'ql-editor' ||
          target.className === 'loading-content' ||
          target.tagName === 'P' ||
          isConfirmationPopUpOpened
        ) {
          /* empty */
        } else {
          if (!initialVisitNoteValue) onSaveVisitNote()
          if (!initialPatientInstructionsValue) onSavePatientInstructions()
        }
      }
      window.addEventListener('click', callBack)
      return () => {
        window.removeEventListener('click', callBack)
      }
    }
  }, [onSaveVisitNote, onSavePatientInstructions, isConfirmationPopUpOpened])

  useEffect(() => {
    if (visitInfo) {
      setIsOwnVisitEditMode((isEndedStatus || isUpcomingVisit) && visitInfo?.ProviderId === currentProviderId)
      setVisitNotesList(visitInfo?.Notes)
      setPatientInstructionsList(visitInfo?.PatientInstructions)
    }
  }, [isEndedStatus, visitInfo, visitInfo?.Notes, visitInfo?.PatientInstructions])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const alertUser = (e) => {
    e.preventDefault()
    e.returnValue = ''
  }
  const areCurrentICDEqual = () => {
    if (currentICDCodesList.current?.length === currentSortedICDCodesList.current?.length) {
      for (let i = 0; i < currentICDCodesList.current?.length; i += 1) {
        if (!_.isEqual(currentICDCodesList.current[i], currentSortedICDCodesList.current[i])) {
          return false
        }
      }
    } else {
      return false
    }
    return true
  }

  useEffect(() => {
    if (isEditingICDCodes.current && !areCurrentICDEqual()) {
      setICDCodesChanged(true)
    } else {
      setICDCodesChanged(false)
    }

    if (
      notesAddendumText?.trim()?.length > 0 ||
      patientInstructionsAddendumText?.trim()?.length > 0 ||
      isNeedToCheckEndedPastVisitBeforeRedirect ||
      isNeedToCheckUpcomingVisitBeforeRedirect ||
      (isEditingICDCodes.current && !areCurrentICDEqual())
    ) {
      window.addEventListener('beforeunload', alertUser)
      setIsSomeValueWasChanged(true)

      window.onpopstate = () => {
        window.history.go(1)
        setIsConfirmationPopUpOpened(true)
      }
      window.addEventListener('beforeunload', alertUser)
      return () => {
        window.removeEventListener('beforeunload', alertUser)
        window.onpopstate = null
      }
    }
    setIsSomeValueWasChanged(false)

    window.onpopstate = () => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      window.history.back(2)
    }

    if (
      (initialVisitNoteValue !== null ||
        initialPatientInstructionsValue !== null ||
        (isUpcomingVisit && initialVisitNoteValue !== visitNoteLocalValue.trim()) ||
        (isEditingICDCodes.current && !areCurrentICDEqual())) &&
      isOwnVisitEditMode
    ) {
      if (
        initialVisitNoteValue !== visitNoteLocalValue.trim() ||
        initialPatientInstructionsValue !== patientInstructionsLocalValue.trim() ||
        (!isEndedStatus &&
          (notesAddendumText?.trim()?.length > 0 ||
            patientInstructionsAddendumText?.trim()?.length > 0 ||
            (isEditingICDCodes.current && !areCurrentICDEqual())))
      ) {
        setIsSomeValueWasChanged(true)
        window.addEventListener('beforeunload', alertUser)
        //

        // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
        window.onpopstate = (e) => {
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          window.history.forward(1)
          setIsConfirmationPopUpOpened(true)
        }
      } else {
        setIsSomeValueWasChanged(false)
        window.onpopstate = null
      }
    }
    return () => {
      window.removeEventListener('beforeunload', alertUser)
      window.onpopstate = null
    }
  }, [
    isEndedStatus,
    patientInstructionsAddendumText,
    notesAddendumText,
    visitNoteLocalValue,
    patientInstructionsLocalValue,
    initialPatientInstructionsValue,
    initialVisitNoteValue,
    isEditingICDCodes.current,
    addedICDCodes,
    sortedVisitICDCodes,
    isNeedToCheckEndedPastVisitBeforeRedirect,
    isNeedToCheckUpcomingVisitBeforeRedirect,
  ])

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (pastVisits?.length && !providerInfo) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setProviderInfo(pastVisits.find(({ VisitId }) => VisitId === visitId)?.Provider)
    }
  }, [pastVisits])

  useEffect(() => {
    if (isVisitNotesSavedSuccess) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setIsVisitNotesSavedSuccess())
      setInitialVisitNoteValue(visitNoteLocalValue.trim())
      initialVisitNoteValueRef.current = visitNoteLocalValue.trim()
    }

    if (isPatientInstructionSavedSuccess) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setIsPatientInstructionsSavedSuccess())
      setInitialPatientInstructionsValue(patientInstructionsLocalValue.trim())
      initialPatientInstructionsValueRef.current = patientInstructionsLocalValue.trim()
    }

    if (
      (isVisitNotesSavedSuccess ||
        isPatientInstructionSavedSuccess ||
        isNoteAddendumSuccessfullyAdded ||
        isPatientInstructionsAddendumSuccessfullyAdded ||
        icdCodesUpdatedSuccess) &&
      (isSaveConfirmationBtnClicked || isCloseBtnClicked)
    ) {
      if (
        newActiveTab &&
        (isNoteAddendumSuccessfullyAdded || isPatientInstructionsAddendumSuccessfullyAdded || icdCodesUpdatedSuccess)
      ) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (newActiveTab.redirect === 'logout') {
          setNewActiveTab('')
          dispatch({ type: LOGOUT, reason: 'manual' })
          safeLocalStorage.set('isSidePanelCollapsed', JSON.stringify(false))
        } else {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          navigate(`/${newActiveTab.redirect}`, { replace: true })
          setNewActiveTab('')
          setIsSaveConfirmationBtnClicked(false)
          return
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (breadCrumbsLocation.current.location) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        navigate(breadCrumbsLocation.current.location, { replace: true })
        return
      }
      navigate(`${PATIENT_CHART_PAGE_PATH}?id=${patientId}&ref=${EventLocations.visitNote}`, {
        replace: true,
      })
      setIsSaveConfirmationBtnClicked(false)
    }
  }, [
    isVisitNotesSavedSuccess,
    isPatientInstructionSavedSuccess,
    isNoteAddendumSuccessfullyAdded,
    isPatientInstructionsAddendumSuccessfullyAdded,
    isSaveConfirmationBtnClicked,
    isCloseBtnClicked,
    dispatch,
    visitNoteLocalValue,
    patientInstructionsLocalValue,
    navigate,
    icdCodesUpdatedSuccess,
    patientId,
  ])

  useEffect(() => {
    if (error) {
      setForceSearchLoading(false)
      if (error === getUserFriendlyErrorMessage(errorCodes.VISIT_HAS_COMPLETED)) {
        navigate(`${PATIENT_CHART_PAGE_PATH}?id=${patientId}`)
        if (!isFirstRender) {
          setLocalError(getUserFriendlyErrorMessage(errorCodes.VISIT_HAS_COMPLETED))
        }
        dispatch(setChartError({ errorMsg: getUserFriendlyErrorMessage(errorCodes.VISIT_HAS_COMPLETED), tabId }))
      }
      if (!isFirstRender) {
        setLocalError(error)
      }
      setTimeout(() => {
        dispatch(setChartError({ errorMsg: '', visitId, tabId }))
      }, 3500)
    }
  }, [error])

  useEffect(() => {
    if (localError) {
      setTimeout(() => {
        setLocalError('')
      }, 3500)
    }
  }, [localError])

  useEffect(() => {
    if (waitingRoomError) {
      if (waitingRoomError === getUserFriendlyErrorMessage(errorCodes.VISIT_HAS_COMPLETED)) {
        dispatch(setChartError({ errorMsg: waitingRoomError, visitId, tabId }))
      }
      setTimeout(() => {
        dispatch(setWaitingRoomError())
      }, 3500)
    }
  }, [waitingRoomError])

  useEffect(() => {
    // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
    let delayDebounceFn
    if (searchText.length >= 3) {
      delayDebounceFn = setTimeout(() => {
        const searchId = Math.random()
        setICDCodeSearchId(searchId)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(searchForICDCodes(searchText, visitId, searchId))
        setForceSearchLoading(true)
      }, 500)
    } else {
      setICDSearchResults(null)
      if (
        addedICDCodes.length === 0 &&
        sortedVisitICDCodes.length &&
        visitInfo?.Status !== UNRESOLVED.toLowerCase() &&
        visitInfo?.Status !== RESOLVED.toLowerCase()
      ) {
        if (isEditingIcdCodes) {
          setSortedVisitICDCodes([])
          currentSortedICDCodesList.current = []
        } else {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(updateICDCodes({ visitId, codes: [], tabId }))
        }
      }
    }

    // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
    return () => clearTimeout(delayDebounceFn)
  }, [searchText])
  const onClickCloseConfirmationPopUp = () => {
    setIsConfirmationPopUpOpened(false)
  }
  const onPressSavePopUpAddendum = useCallback(() => {
    if (notesAddendumText.trim()) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(saveVisitNotesAddendum({ visitId, Note: notesAddendumText.trim(), isWithoutSaving: true, tabId }))
    }
    if (patientInstructionsAddendumText.trim()) {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        savePatientInstructionsAddendum({
          visitId,
          PatientInstructions: patientInstructionsAddendumText.trim(),
          isWithoutSaving: true,
          tabId,
        }),
      )
    }
    if (icdCodesChanged) {
      if (!sortedVisitICDCodes.length && visitInfo?.Status === 'completed' && !isInPersonVisit) {
        setLocalError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
        setLocalICDCodesError(getUserFriendlyErrorMessage(errorCodes.ICD_CODE_MISSING))
      } else {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(updateICDCodes({ visitId, codes: currentICDCodesList.current, tabId }))
      }
    }
  }, [dispatch, icdCodesChanged, notesAddendumText, patientInstructionsAddendumText, visitId])
  const onClickSaveBtnConfirmationPopUp = () => {
    setIsSaveConfirmationBtnClicked(true)
    if (isVisitCancelled && initialVisitNoteValue === visitNoteLocalValue.trim()) {
      navigate(`${PATIENT_CHART_PAGE_PATH}?id=${patientId}&ref=${EventLocations.visitNote}`)
      dispatch(clearCancelledVisitId())
    }
    if (isEndedStatus || isUpcomingVisit) {
      onClickCloseConfirmationPopUp()
      onSaveVisitNote()
      onSavePatientInstructions()
    } else {
      onClickCloseConfirmationPopUp()
      onPressSavePopUpAddendum()
    }
  }

  const onClickDiscardBtnConfirmationPopUp = useCallback(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (breadCrumbsLocation.current.location) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      navigate(breadCrumbsLocation.current.location, { replace: true })
      return
    }
    if (newActiveTab) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (newActiveTab.redirect === 'logout') {
        setNewActiveTab('')
        dispatch({ type: LOGOUT, reason: 'manual' })
        safeLocalStorage.set('isSidePanelCollapsed', JSON.stringify(false))
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        navigate(`/${newActiveTab.redirect}`, { replace: true })
        setNewActiveTab('')
        return
      }
    }
    onClickCloseConfirmationPopUp()
    navigate(`${PATIENT_CHART_PAGE_PATH}?id=${patientId}&ref=${EventLocations.visitNote}`)
  }, [dispatch, navigate, newActiveTab, patientId])

  useEffect(() => {
    if (loading || notesChangeLoading || forceSearchLoading || remarksLoading) {
      // If any loading state is true, start/refresh the timer
      if (loadingTimerId) {
        clearTimeout(loadingTimerId)
      }

      const timerId = setTimeout(() => {
        // After LONG_LOADING_THRESHOLD (20 seconds), if still loading, log the event
        appInsights.trackEvent({
          name: 'LongLoadingDetected',
          properties: {
            component: 'PatientPastVisitNotes',
            message: 'Loading states persisted beyond threshold',
            visitId,
            patientId,
            loading: loading ? 'true' : 'false',
            notesChangeLoading: notesChangeLoading ? 'true' : 'false',
            forceSearchLoading: forceSearchLoading ? 'true' : 'false',
            remarksLoading: remarksLoading ? 'true' : 'false',
          },
        })
      }, 20000)

      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setLoadingTimerId(timerId)
    } else if (loadingTimerId) {
      // If not loading and a timer was set, clear it
      clearTimeout(loadingTimerId)
      setLoadingTimerId(null)
    }

    return () => {
      if (loadingTimerId) {
        clearTimeout(loadingTimerId)
      }
    }
  }, [loading, notesChangeLoading, forceSearchLoading, remarksLoading, loadingTimerId, visitId, patientId])
  const onClickClose = () => {
    const isNeedToCheckChangedValues = isEndedStatus ? isNeedToCheckEndedPastVisitBeforeRedirect : isSomeValueWasChanged

    if (
      patientInstructionsAddendumText ||
      notesAddendumText ||
      icdCodesChanged ||
      isVisitCancelled ||
      isNeedToCheckChangedValues
    ) {
      setIsConfirmationPopUpOpened(true)
      return
    }
    if (isSomeValueWasChanged) {
      setIsCloseBtnClicked(true)
    } else {
      navigate(`${PATIENT_CHART_PAGE_PATH}?id=${patientId}&ref=${EventLocations.visitNote}`)
    }
  }
  const onClickCancelBtnUnresolvedReasonPopUp = useCallback(() => {
    setIsUnresolvedReasonPopUpOpened(false)
  }, [])

  const onClickUnresolvedPopUpReasonSaveBtn = useCallback(() => {
    if (!unresolvedReasonPopUpDropdownValue) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setIsUnresolvedReasonPopUpError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Reason'))
      dispatch(setChartError({ errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS), visitId, tabId }))
    } else if (
      unresolvedReasonPopUpDropdownValue === OTHER_DROPDOWN_OPTION &&
      unresolvedReasonPopUpMessageText?.length === 0
    ) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setIsUnresolvedReasonPopUpError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Reason'))
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.FILL_ALL_FIELDS))
    } else if (
      unresolvedReasonPopUpDropdownValue === OTHER_DROPDOWN_OPTION &&
      unresolvedReasonPopUpMessageText?.length > unresolvedVisitPopUpTextBoxCounterLimit
    ) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setIsUnresolvedReasonPopUpError(getUserFriendlyErrorMessage(errorCodes.MAX_CHARACTER_LIMIT, null, 'Reason'))
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.FILL_ALL_FIELDS))
    } else {
      onSaveVisitNote()
      onSavePatientInstructions()
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        unresolveVisit({
          visitId,
          message:
            unresolvedReasonPopUpDropdownValue === OTHER_DROPDOWN_OPTION ?
              unresolvedReasonPopUpMessageText
            : unresolvedReasonPopUpDropdownValue,
          tabId,
        }),
      )
    }
  }, [dispatch, unresolvedReasonPopUpDropdownValue, unresolvedReasonPopUpMessageText?.length, visitId])

  const setUnresolvedReasonPopUpDropdownOption = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setUnresolvedReasonPopUpDropdownValue(value)
      setIsUnresolvedReasonPopUpError('')
      setUnresolvedReasonPopUpMessageText('')
      dispatch(setChartError({ errorMsg: '', visitId, tabId }))
    },
    [dispatch, visitId],
  )
  const setUnresolvedReasonPopUpMessage = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setUnresolvedReasonPopUpMessageText(value)
      setIsUnresolvedReasonPopUpError('')
      dispatch(setError(''))
    },
    [dispatch],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeSearchInputValue = (value) => {
    const searchValue = value.trim()
    setSearchText(searchValue)
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSelectICDCode = useCallback((code) => {
    setAddedICDCodes((codes) => {
      const newCodes = [...codes]
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const found = newCodes.findIndex((icdCode) => icdCode.IcdCodeId === code.id)
      if (found === -1) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        newCodes.push({ Code: code.name, Description: code.description, IcdCodeId: code.id })
      }
      window.onbeforeunload = function (e) {
        e.preventDefault()
        e.returnValue = ''
      }
      currentICDCodesList.current = [...newCodes]

      return newCodes
    })
  }, [])
  const onDeleteCode = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (deletedCode) => {
      setAddedICDCodes((codes) => {
        const currentCodes = [...codes]
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        const updatedCodes = currentCodes.filter((code) => deletedCode.IcdCodeId !== code.IcdCodeId)
        if (updatedCodes.length === 0 && sortedVisitICDCodes.length && searchText.length === 0) {
          if (isEditingIcdCodes) {
            setSortedVisitICDCodes([])
            currentSortedICDCodesList.current = []
          } else {
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            dispatch(updateICDCodes({ visitId, codes: [], tabId }))
          }
        }
        currentICDCodesList.current = [...updatedCodes]
        return updatedCodes
      })
    },
    [visitId, sortedVisitICDCodes, searchText, isEditingIcdCodes, dispatch],
  )
  const onUpdateICDCodes = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (deletedCodeId, update = true, forceUpdate = false, willClose = false) => {
      let updateAPI = false

      if (willClose && !isEditingICDCodes.current) {
        if (currentICDCodesList.current.length !== currentSortedICDCodesList.current.length) {
          updateAPI = true
        } else {
          for (let i = 0; i < currentSortedICDCodesList.current.length; i += 1) {
            // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
            if (currentICDCodesList.current[i].IcdCodeId !== currentSortedICDCodesList.current[i].IcdCodeId) {
              updateAPI = true
              i = currentSortedICDCodesList.current.length
            }
          }
        }
        if (updateAPI) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(updateICDCodes({ visitId, codes: currentICDCodesList.current, tabId }))
        }
        return
      }
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setAddedICDCodes((codes) => {
        if (deletedCodeId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          const newCodeList = codes.filter((code) => code.IcdCodeId !== deletedCodeId)
          if (update) {
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            dispatch(updateICDCodes({ visitId, codes: newCodeList, tabId }))
            window.onbeforeunload = null
          } else {
            setSortedVisitICDCodes(newCodeList)
            if (!isEditingICDCodes.current) currentSortedICDCodesList.current = [...newCodeList]
          }
          currentICDCodesList.current = [...newCodeList]

          return newCodeList
        }
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        codes.sort((a, b) => a.Code.localeCompare(b.Code))

        if (codes?.length === actualSortedIcdCodesListForBlurUpdate?.length) {
          for (let i = 0; i < actualSortedIcdCodesListForBlurUpdate?.length; i += 1) {
            // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
            if (codes[i].IcdCodeId !== actualSortedIcdCodesListForBlurUpdate[i].IcdCodeId) {
              updateAPI = true
              i = actualSortedIcdCodesListForBlurUpdate.length
            }
          }
        } else {
          updateAPI = true
        }
        if ((updateAPI && update) || forceUpdate) {
          if (
            forceUpdate &&
            !actualSortedIcdCodesListForBlurUpdate.length &&
            visitInfo?.Status !== RESOLVED.toLowerCase() &&
            visitInfo?.Status !== UNRESOLVED.toLowerCase() &&
            visitInfo?.Status !== ENDED.toLowerCase() &&
            !isInPersonVisit
          ) {
            dispatch(
              setChartError({
                errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
                visitId,
                tabId,
              }),
            )
            setLocalICDCodesError(getUserFriendlyErrorMessage(errorCodes.ICD_CODE_MISSING))
            currentICDCodesList.current = [...codes]
            return codes
          }
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(updateICDCodes({ visitId, codes, tabId, isBlurUpdate: true }))
          window.onbeforeunload = null
        } else if (!update) {
          if (localICDCodesError) {
            setLocalICDCodesError('')
          }

          setSortedVisitICDCodes(codes)
          if (!isEditingICDCodes.current) currentSortedICDCodesList.current = [...codes]

          currentICDCodesList.current = [...codes]
          return codes
        }
        // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
        return actualSortedIcdCodesListForBlurUpdate
      })
    },
    [
      dispatch,
      visitId,
      sortedVisitICDCodes,
      visitInfo?.Status,
      localICDCodesError,
      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      actualSortedIcdCodesListForBlurUpdate,
    ],
  )
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetPatientInstructionsLocalValue = (value, isNeedToUpdateValueForAnotherTabs) => {
    setPatientInstructionsLocalValue(value)
    patientInstructionsLocalValueRef.current = value

    if (isNeedToUpdateValueForAnotherTabs) {
      setNewPatientInstructionValue(value)
    }
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetInitialPatientInstructionsValue = (value) => {
    setInitialPatientInstructionsValue(value)
    initialPatientInstructionsValueRef.current = value
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetVisitNoteLocalValue = (value, isNeedToUpdateValueForAnotherTabs) => {
    setVisitNoteLocalValue(value)
    visitNoteLocalValueRef.current = value
    if (isNeedToUpdateValueForAnotherTabs) {
      setNewNoteValue(value)
    }
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetInitialVisitNoteValue = (value) => {
    setInitialVisitNoteValue(value)
    initialVisitNoteValueRef.current = value
  }

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const onShowConfirmationPopUp = (breadCrumbLocation) => {
    breadCrumbsLocation.current = breadCrumbLocation
    setIsConfirmationPopUpOpened(true)
  }

  const onOpenAddRemark = () => {
    setAddRemarkOpen(true)
    toggleVisitRemarks(true, true)
  }

  const addNewRemark = () => {
    if (textareaValue.trim()) {
      tracking.trackEvent(PROVIDER_EVENT_NAMES.ADD_VISIT_REMARK, {
        FromDateTime: visitInfo?.FromDateTime,
        IsNewForPatient: visitInfo?.IsNewForPatient,
        IsPatientAvailable: visitInfo?.IsPatientAvailable,
        Method: visitInfo?.Method,
        PatientId: visitInfo?.PatientId,
        ServiceTypeName: visitInfo?.ServiceTypeName,
        // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
        Status: visitInfo?.Status,
        ToDateTime: visitInfo?.ToDateTime,
        VisitId: visitInfo?.VisitId,
        VisitTypeName: visitInfo?.VisitTypeName,
      })

      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        createVisitRemarks({
          visitId,
          tabId,
          Message: textareaValue.trim().replaceAll('<br>', '\n'),
          isForceUpdate: false,
        }),
      )
    }

    setTextareaValue('')
    setAddRemarkOpen(false)
  }

  const onEditRemark = useCallback(() => {
    if (textareaValue.trim()) {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        updateUpcomingVisitRemark({
          visitId,
          remarkId: editRemarkId,
          Message: textareaValue.trim().replaceAll('<br>', '\n'),
        }),
      )
    }
    setTextareaValue('')
    dispatch(setEditRemarkId(null))
    setEditRemark('')
    setAddRemarkOpen(false)
  }, [dispatch, editRemarkId, textareaValue, visitId])

  const onCancelAddRemark = () => {
    setAddRemarkOpen(false)
    setTextareaValue('')

    setEditRemark('')
    dispatch(setEditRemarkId(null))
  }

  const dateTimeValue = parseUserDateTime(moment(visitInfo?.FromDateTime), timeZone, true)
  const isLoading = loading || notesChangeLoading || forceSearchLoading || remarksLoading || forceLoading

  return (
    <>
      {pageHeader}
      <PastVisitNotesListener
        visitId={visitId}
        patientId={patientId}
        onSetVisitNoteLocalValue={onSetVisitNoteLocalValue}
        onSetPatientInstructionsLocalValue={onSetPatientInstructionsLocalValue}
        setNotesAddendumText={setNotesAddendumText}
        setIsNotesAddendumPressed={setIsNotesAddendumPressed}
        setPatientInstructionsAddendumText={setPatientInstructionsAddendumText}
        setIsPatientInstructionsAddendumPressed={setIsPatientInstructionsAddendumPressed}
        setIsResetEditModeIcdCodes={setIsResetEditModeIcdCodes}
        setEndedVisitId={setEndedVisitId}
        setIsLoading={setForceLoading}
      />
      {isUnresolvedReasonPopUpOpened ?
        <UnresolvedVisitReasonPopUp
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          onClickCancelBtn={onClickCancelBtnUnresolvedReasonPopUp}
          onClickSaveBtn={onClickUnresolvedPopUpReasonSaveBtn}
          popUpError={isUnresolvedReasonPopUpError}
          dropdownValue={unresolvedReasonPopUpDropdownValue}
          setDropdownValue={setUnresolvedReasonPopUpDropdownOption}
          setPopUpText={setUnresolvedReasonPopUpMessage}
          popUpText={unresolvedReasonPopUpMessageText}
          textBoxValueLengthLimit={unresolvedVisitPopUpTextBoxCounterLimit}
        />
      : null}
      {isConfirmationPopUpOpened ?
        // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
        <ConfirmationPopup
          additionalContainerClass='patient-past-visit-note-confirmation-popup'
          title={popupTitle}
          subTitle={popupMessageSub}
          primaryBtnAction={onClickSaveBtnConfirmationPopUp}
          primaryBtnText={primaryButtonText}
          secondaryBtnAction={onClickDiscardBtnConfirmationPopUp}
          secondaryBtnText={secondaryButtonText}
          msg={popupMessage}
          isCancelledStatus={isVisitCancelled}
          closeAction={onClickCloseConfirmationPopUp}
        />
      : null}
      <DeleteRemarkPopup />
      {localError || waitingRoomError ?
        <ErrorAlert
          styleContainer={errorAlertContainerStyle}
          errorText={localError || waitingRoomError}
          errorImg={errorIcon}
          imgAlt='Error'
        />
      : null}

      {isLoading ?
        <PageLoadingSpinner />
      : null}

      <PageLayout>
        {visitInfo ?
          <>
            <PastVisitNotesHeader
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              dateTimeValue={dateTimeValue}
              onClickClose={onClickClose}
              onSaveVisitNote={onSaveVisitNote}
              setVisitStatus={onSetVisitStatus}
              isNotCompleted={isOwnVisitEditMode}
              visitNotesList={visitNotesList}
            />
            <div className='patient-past-visit-notes-body'>
              {patientInfo ?
                <PatientInfoCard isUpcomingVisit={isUpcomingVisit} providerInfo={providerInfo} visitId={visitId} />
              : null}
              <div
                className={classNames('patient-past-visit-notes-remarks-container', {
                  'add-remark-is-open': isAddRemarkOpen,
                })}>
                <ChartCard
                  isWithoutLastUpdate
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  defaultCollapsed
                  title='Visit remarks'
                  className='patient-past-visit-notes-remarks'
                  chartCardId='visitRemark'
                  showEmpty={false}
                  additionalChartCardStyle={additionalChartCardStyle}
                  image={ringIcon}
                  data={visitRemarks?.remarksList || []}
                  patientInfo={patientInfo}
                  showInfo={showVisitRemarks}
                  toggleShowInfo={toggleVisitRemarks}
                  showTimeZones
                  rightButton={
                    !isAddRemarkOpen && showVisitRemarks ?
                      // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                      <SecondaryButton
                        btnText='New'
                        containerStyle={AddRemarkBtnStyle}
                        image={plus}
                        imageAlt='NewRemark'
                        imageStyle={NewRemarkBtnImgStyle}
                        onPress={onOpenAddRemark}
                      />
                    : null
                  }>
                  <>
                    {isAddRemarkOpen ?
                      <AddRemark
                        isEditMode={!!editRemarkId}
                        remarkValue={textareaValue}
                        onChange={onTextareaValueChange}
                        onRemarkAdd={addNewRemark}
                        onEditRemark={onEditRemark}
                        onCancel={onCancelAddRemark}
                      />
                    : null}
                    {visitRemarks?.remarksList.length ?
                      <VisitRemarksContent
                        isFormOpened={isAddRemarkOpen}
                        userTimeZone={userTimeZone}
                        userTimeZoneAbbr={parsedAdminTimeZoneAbbr}
                        remarks={visitRemarks}
                      />
                    : <span className='chart-card-no-records'>No visit remarks</span>}
                  </>
                </ChartCard>
              </div>
              <div className='patient-past-visit-note-block'>
                <div className='patient-past-visit-note-block-title'>{VISIT_NOTE_TEXT}</div>
                <NotesSection
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  title={VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE}
                  editorTitle={VISIT_NOTE_BLOCK_EDITOR_TITLE}
                  isEndedStatus={isEndedStatus}
                  isCancelledStatus={isCancelledStatus}
                  isUpcomingVisit={isUpcomingVisit}
                  notesList={visitNotesList}
                  value={visitNoteLocalValue}
                  setValue={onSetVisitNoteLocalValue}
                  onSetNewAddendumText={onSetNotesAddendumTextValue}
                  setInitialValue={onSetInitialVisitNoteValue}
                  emptyText={NO_NOTES_TEXT}
                  isNotCompleted={isOwnVisitEditMode}
                  onPressAddendum={onNotesSectionPressAddendum}
                  isAddendumTextEditorActive={isNotesAddendumPressed}
                  onCancelAddendum={onNotesSectionPressCancelAddendum}
                  onSaveAddendum={onPressSaveNoteAddendum}
                  addendumLocalError={notesAddendumError}
                  addendumRef={addendumNoteRef}
                  autoSave={onSaveVisitNote}
                  newValue={newNoteValue}
                />
                <PrescriptionsSection
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  patientId={patientId}
                  patientInfo={patientInfo}
                  tabId={tabId}
                  isNotCompleted={isOwnVisitEditMode}
                  isCancelledStatus={isCancelledStatus}
                  isUpcomingVisit={isUpcomingVisit}
                  description={!isUpcomingVisit && VISIBLE_TO_PATIENT_IN_VISIT_SUMMARY_TEXT}
                />
                {/*
                 // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
                <ICDCodes
                  isInPersonVisit={visitInfo?.Method === VisitMethods.INPERSON}
                  onSearch={onChangeSearchInputValue}
                  icdSearchResults={icdSearchResults}
                  onSelectICDCode={onSelectICDCode}
                  addedICDCodes={addedICDCodes}
                  isUpcomingVisit={isUpcomingVisit}
                  isCancelledStatus={isCancelledStatus}
                  updateICDCodes={onUpdateICDCodes}
                  visitICDCodes={sortedVisitICDCodes}
                  isReadOnly={isEndedStatus ? visitInfo?.ProviderId !== currentProviderId : null}
                  isEditing={isEditingIcdCodes}
                  hasEnded={!isEndedStatus}
                  localError={localICDCodesError}
                  isDetailsMode
                  deleteCode={onDeleteCode}
                  isIcdCodesChanged={isIcdCodesChanged}
                  deleteCodeFromList={onUpdateICDCodes}
                  setLocalPastVisitPageError={setLocalError}
                  setLocalICDCodesError={setLocalICDCodesError}
                  visitStatus={visitInfo?.Status}
                  isForceUpdateIcdCodes={isForceUpdateIcdCodes}
                  setIsForceUpdateIcdCodes={setIsForceUpdateIcdCodes}
                  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                  editIcdCodes={(value) => {
                    if (!value) {
                      const sortedCodes = [...visitICDCodes].sort((a, b) => a.Code.localeCompare(b.Code))
                      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                      setSortedVisitICDCodes(sortedCodes)
                      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                      currentSortedICDCodesList.current = [...sortedCodes]

                      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                      setAddedICDCodes(sortedCodes)
                      setSearchText('')
                      setICDSearchResults(null)
                    }
                    setIsEditingIcdCodes(value)
                    isEditingICDCodes.current = value
                  }}
                />
                <NotesSection
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  className='patient-past-visit-note-block-patient-instructions'
                  title={PATIENT_INSTRUCTIONS_TITLE_TEXT}
                  editorTitle={PATIENT_INSTRUCTIONS_EDITOR_TITLE_TEXT}
                  description={!isUpcomingVisit && VISIBLE_TO_PATIENT_IN_VISIT_SUMMARY_TEXT}
                  onSetNewAddendumText={onSetPatientsInstructionsAddendumTextValue}
                  isEndedStatus={isEndedStatus}
                  isCancelledStatus={isCancelledStatus}
                  isUpcomingVisit={isUpcomingVisit}
                  notesList={patientInstructionsList}
                  value={patientInstructionsLocalValue}
                  setValue={onSetPatientInstructionsLocalValue}
                  setInitialValue={onSetInitialPatientInstructionsValue}
                  emptyText={NO_PATIENT_INSTRUCTIONS_TEXT}
                  isNotCompleted={isOwnVisitEditMode}
                  onPressAddendum={onPatientInstructionsSectionPressAddendum}
                  isAddendumTextEditorActive={isPatientInstructionsAddendumPressed}
                  onCancelAddendum={onPatientInstructionsSectionPressCancelAddendum}
                  isWithoutSeparator
                  addendumLocalError={patientInstructionsAddendumError}
                  onSaveAddendum={onPressSavePatientInstructionsAddendum}
                  addendumRef={addendumPatientInstructionsRef}
                  autoSave={onSavePatientInstructions}
                  newValue={newPatientInstructionValue}
                />
              </div>
            </div>
          </>
        : null}
      </PageLayout>
    </>
  )
})
